import React, { FC } from "react";
import { useSelector } from "react-redux";

import { Card, Label, ReadOnlyCardField, SelectionCard } from "../../common";
import { useInvoiceCurrencies } from "../../../hooks/useInvoiceCurrencies";
import { selectInvoice } from "../../../store/reducers/invoice";
import { getCountryName } from "../../../utils/address";
import { formatDate, DateFormat } from "../../../utils/date";
import { formatAmount } from "../../../utils/numbers/money";

export const InvoiceSummary: FC = () => {
  const invoice = useSelector(selectInvoice);
  const invoiceCurrencies = useInvoiceCurrencies(invoice);

  if (!invoice) {
    return <></>;
  }

  const {
    issuer_data,
    payer_data,
    items,
    issued_at,
    due_at,
    outgoing_payment_details,
  } = invoice;

  return (
    <div className="flex flex-col gap-4">
      <ReadOnlyCardField label="From">
        <div>{issuer_data?.name}</div>
        <div>
          {issuer_data?.address}, {issuer_data?.postal_code}
        </div>
        <div>
          {issuer_data?.city}, {getCountryName(issuer_data?.country || "")}
        </div>
        <div>Reg. Nº: {issuer_data?.reg_number || "-"}</div>
        <div>Tax ID: {issuer_data?.tax_id || "-"}</div>
      </ReadOnlyCardField>

      <ReadOnlyCardField label="To">
        <div>{payer_data?.name}</div>
        <div>
          {payer_data?.address}, {payer_data?.postal_code}
        </div>
        <div>
          {payer_data?.city}, {getCountryName(payer_data?.country || "")}
        </div>
        <div>Reg. Nº: {payer_data?.reg_number || "-"}</div>
        <div>Tax ID: {payer_data?.tax_id || "-"}</div>
      </ReadOnlyCardField>

      <Label
        label="Job"
        labelClassName="!text-base"
        valueClassName="flex flex-col gap-2"
      >
        {items?.map(({ description, rate }, index) => (
          <Card
            className="flex justify-between bg-white/50 rounded-lg"
            key={`invoice-item-${index}`}
          >
            <div>{description}</div>
            <div>
              {invoiceCurrencies?.input?.symbol} {formatAmount(rate)}
            </div>
          </Card>
        ))}
      </Label>

      <div className="flex gap-4 justify-evenly">
        <ReadOnlyCardField label="Issue date">
          {formatDate(issued_at, DateFormat.d_MMM_yyyy)}
        </ReadOnlyCardField>

        <ReadOnlyCardField label="Due date to pay">
          {formatDate(due_at, DateFormat.d_MMM_yyyy)}
        </ReadOnlyCardField>
      </div>

      {outgoing_payment_details && (
        <Label
          label="Get paid on"
          labelClassName="!text-base theme-text"
          valueClassName="flex flex-col gap-2"
        >
          <SelectionCard
            title={`${outgoing_payment_details.chain} - ${outgoing_payment_details.name}`}
            value={
              outgoing_payment_details.address ||
              outgoing_payment_details.iban ||
              outgoing_payment_details.bic ||
              `${outgoing_payment_details.bank_name} - ${outgoing_payment_details.account_number}` ||
              ""
            }
            className="bg-white/50"
            onClick={() => {}}
          />
        </Label>
      )}
    </div>
  );
};
